export default __webpack_public_path__ + "static/SRUS SBL702 - Product Specifications & Technical Data-896764ded24c2ff0b05a8b3d63d4fbf3.pdf";